<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.home')"
      >Perfil de {{ studentProfile.student.name }}</back-profile
    >

    <block :bordered-header="true" style="padding-bottom: 30px;">
      <template slot="header"
        >Información adicional</template
      >

      <div class="info-sections">
        <div v-for="section in sections" :key="section.title" class="info-section">
          <h4 class="info-section-title is-uppercase has-text-weight-medium">
            {{ section.title }}
          </h4>
          <div class="info-items">
            <div v-for="item in section.items" :key="item.name" class="info-item">
              <div class="item-field">{{ item.name }}</div>
              <div class="item-content">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"

import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"

export default {
  name: "ProfileExtraInfo",
  props: {
    studentId: {
      type: String
    }
  },

  data() {
    return {
      studentProfile: {
        student: {
          responsible: {},
          enrolledSince: {},
          enrollments: [],
          data: {}
        }
      }
    }
  },

  apollo: {
    studentProfile: {
      query: gql`
        query StudentProfile($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              id
              name
              phoneNumber
              phoneNumbers
              email
              emailAddresses
              address
              district
              enrolledSince {
                id
                name
              }
              enrollments {
                id
                term {
                  id
                  name
                }
                program {
                  id
                  name
                  locationName
                  deparmentName
                  shiftName
                }
              }
              data {
                __typename
                ... on CucData {
                  fechaNacimiento
                  genero
                  municipio
                  valorMatricula
                  becaDescripcion
                  becaValor
                  becaCobertura
                  ocupacionMadre
                  ocupacionPadre
                  poseeComputador
                  tieneAccesoAInternet
                  poseeCelularInteligente
                  tienePlanDatos
                  integrantesFamilia
                  numeroHijos
                  discapacidad
                  grupoEtnico
                  comunidad
                  registroVictimas
                  tieneSeguroSalud
                  enfermedadEspecial
                  tieneEnfermedadEspecial
                  trabaja
                  empresa
                  colegio
                  tipoColegio
                  puntuacion
                  inclusion
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    }
  },

  computed: {
    info() {
      return this.studentProfile.student.data || {}
    },

    // TODO: This is duplicated from `ProfileInfo.vue`
    formattedProgramLine() {
      const enrollments = this.studentProfile.student.enrollments || []
      if (enrollments.length == 0) {
        return "-"
      }
      const e = enrollments[0]
      return [
        e.program.locationName,
        e.program.shiftName,
        e.program.deparmentName,
        e.program.name
      ].join(" | ")
    },

    sections() {
      const info = this.info

      // Calculate phones
      const phones =
        this.studentProfile.student && this.studentProfile.student.phoneNumbers
          ? this.studentProfile.student.phoneNumbers.map((v, index) => {
              return {
                name: index == 0 ? "Teléfono" : `Teléfono ${index + 1}`,
                value: v
              }
            })
          : ""

      // Calculate emails
      const emails =
        this.studentProfile.student && this.studentProfile.student.emailAddresses
          ? this.studentProfile.student.emailAddresses.map((v, index) => {
              return {
                name: index == 0 ? "Email" : `Email ${index + 1}`,
                value: v
              }
            })
          : ""

      const generalInfo = {
        title: "General",
        items: [
          { name: "Fecha Nacimiento", value: info.fechaNacimiento },
          { name: "Género", value: info.genero },
          { name: "Municipio", value: this.studentProfile.student.district },
          { name: "Dirección", value: this.studentProfile.student.address },
          ...phones,
          ...emails
        ]
      }

      const institutionalInfo = {
        title: "Matrícula",
        items: [
          { name: "Programa", value: this.formattedProgramLine },
          {
            name: "Cohorte de Ingreso",
            value:
              this.studentProfile.student.enrolledSince &&
              this.studentProfile.student.enrolledSince.name
                ? this.studentProfile.student.enrolledSince.name
                : ""
          },
          {
            name: "Valor matrícula",
            value: this.formatNumericValue(info.valorMatricula)
          },
          { name: "Beca/Crédito", value: info.becaDescripcion },
          {
            name: "Valor beca/crédito",
            value: this.formatNumericValue(info.becaValor)
          },
          { name: "Procentaje de cobertura de la beca/crédito", value: info.becaCobertura }
        ]
      }

      const extraInfo = {
        title: "Entrevista",
        items: [
          { name: "Ocupación madre", value: info.ocupacionMadre },
          { name: "Ocupación padre", value: info.ocupacionPadre },
          { name: "Posee computador", value: info.poseeComputador },
          { name: "Acceso a internet", value: info.tieneAccesoAInternet },
          { name: "Celular inteligente", value: info.poseeCelularInteligente },
          { name: "Plan de datos", value: info.tienePlanDatos },
          { name: "Número de hermanos", value: info.hermanos },
          { name: "Integrantes familia", value: info.integrantesFamilia },
          { name: "Número hijos", value: info.numeroHijos },
          { name: "Discapacidad", value: info.discapacidad },
          { name: "Grupo étnico", value: info.grupoEtnico },
          { name: "Comunidad", value: info.comunidad },
          { name: "Registro víctimas", value: info.registroVictimas },
          { name: "Seguro salud", value: info.tieneSeguroSalud },
          { name: "Enfermedad especial", value: info.enfermedadEspecial },
          { name: "Enfermedad", value: info.Enfermedad },
          { name: "Trabaja", value: info.trabaja },
          { name: "Empresa", value: info.trabaja },
          { name: "Colegio", value: info.colegio },
          { name: "Tipo colegio", value: info.tipoColegio },
          { name: "Puntuación", value: info.puntuacion },
          { name: "Inclusión", value: info.inclusion }
        ]
      }

      return [generalInfo, institutionalInfo, extraInfo]
    }
  },

  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    formatNumericValue(value) {
      if (value) {
        return parseInt(value)
          .toLocaleString("es")
          .replace(/,/g, ".")
      } else {
        return ""
      }
    }
  },

  components: {
    Block,
    BackProfile
  }
}
</script>

<style scoped>
h4 {
  margin: 0;
}

.info-section {
  margin: 60px 0;
}

.info-item {
  display: flex;
  margin: 10px 0;
}

.item-field {
  flex-basis: 26%;
}
.item-field::after {
  content: ":";
}
</style>
